import React, { useContext } from 'react';

const AnalyticsContext = React.createContext();

export const useAnalyticsContext = () => useContext(AnalyticsContext);
export default AnalyticsContext;
